<div class="collapse-container">
  <div class="collapse-header mb-2" (click)="collapsed = !collapsed">
    <span>&#9660;</span> <!-- Down arrow, can change to up arrow when collapsed -->
    <span style="margin-left: 8px;">Attachment</span>
  </div>
  @if (!collapsed) {
    <div class="collapse-content" style="  height: 350px !important; overflow-y: auto !important;">
      @if (type === 'video' || isVideo(attachmentName)) {
        <div>
          <video id="update-video" controls width="300" height="300">
            <source [src]="attachmentUrl" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      }
      @if (type === 'image' || isImage(attachmentName)) {
        <div>
          <img
            style="max-width: 100%; height: 350px; image-orientation: from-image;"
            [src]="attachmentUrl"
            [alt]="attachmentName"
            />
          </div>
        }
      </div>
    }
  </div>